import { HttpErrorResponse } from "@angular/common/http";
import { createAction, props } from "@ngrx/store";
import {
  Schedule,
  SchedulePayload,
} from "src/app/shared/interfaces/course-schedule";
import { Guid } from "src/app/shared/types/guid";

export const createSchedulePrefix = "[Create Schedule]";

const createScheduleActions = {
  request: `${createSchedulePrefix} Load`,
  requestSuccess: `${createSchedulePrefix} Load success`,
  requestFail: `${createSchedulePrefix} Load fail`,
};

export const createScheduleLoad = createAction(
  createScheduleActions.request,
  props<{
    CourseId: Guid;
    GroupId: Guid;
    schedule: SchedulePayload;
  }>(),
);

export const createScheduleLoadSuccess = createAction(
  createScheduleActions.requestSuccess,
  props<{ schedule: Schedule }>(),
);

export const createScheduleLoadFailure = createAction(
  createScheduleActions.requestFail,
  props<{ error: HttpErrorResponse }>(),
);
